import { postNotifyAuthAuthorizeReducer } from '../../slices/gq-notification';

export const notifyAuthReducers = {
    postNotifyAuthAuthorize: postNotifyAuthAuthorizeReducer
};